
import React from 'react';
import { TextField } from 'office-ui-fabric-react/lib/TextField';

const STYLES = {
    subComponentStyles: {
        label: {
            root: {
                color: '#999999'
            }
        }
    }
};

const AttributeNumberField = ({
    values,
    onChange,
    fieldTitle,
    fieldName,
    required
}) => {

    const getLabel = () => {
        let label = fieldTitle;
        if (required) {
            label = `${label} (*)`;
        }
        return label;
    }

    const handleChange = (e) => {
        if (onChange) {
            onChange(fieldName, e.target.value);
        }
    }

    return (
        <TextField
            onChange={handleChange}
            value={values[fieldName] || ''}
            label={getLabel()}
            styles={STYLES}
        />
    );
}

export default AttributeNumberField;
